import React from 'react';
import { useSelector } from 'react-redux';
import GiftboxPointPageComponent from '../components/point';
import {usePoint} from "../../../commons/customHooks/GiftBox";
import {useCoupon} from "../../../commons/customHooks/GiftBox";


const GiftboxPageContainer  = () => {
    const [ point,isProcessingPoint ] = usePoint();
    const [ coupons ] = useCoupon();
    console.log(isProcessingPoint, 'isProcessingPoint32432');
    return <GiftboxPointPageComponent point={point} coupon={coupons} isProcessingPoint={isProcessingPoint}

    />;
};

export default GiftboxPageContainer ;